import { styled } from "styled-components";

const ScrollElement = styled.div<{ $bg: string }>`
  position: relative;

  min-height: 130px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;

  padding: 1rem;

  border-radius: 1rem;
  background: ${({ $bg }) => $bg};

  & > p {
    color: ${({ theme }) => theme.colors.white};
    font-size: 1rem;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.02rem;
    z-index: 10;
  }

  & > img {
    position: absolute;
    right: 0;
    top: 0;
    max-width: 162px;
    max-height: 130px;
  }
`;

export default {
  ScrollElement,
};
